import { MarkerClusterer } from "@googlemaps/markerclusterer";
import GoogleMap from "../utils/map";

const Portfolios = {
  map: null,
  element: $("#google-map"),

  init() {
    if (Portfolios.element.length) {
      Portfolios.renderMap();
      Portfolios.getData();
    }
  },

  renderMap() {
    const mapOptions = {
      zoom: 30,
      center: {
        lat: 56.960862,
        lng: 24.105513,
      },
      scrollwheel: false,
      disableDefaultUI: true,
      zoomControl: true,
      styles: GoogleMap.styles,
    };

    Portfolios.map = new google.maps.Map(Portfolios.element[0], mapOptions);
  },

  getData() {
    const post_type = Portfolios.element.data("post-type");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "get_locations",
        post_type: post_type,
      },
    }).then((data) => {
      Portfolios.renderMarkers(data);
    });
  },

  renderMarkers(data) {
    let markers = [];

    const bounds = new google.maps.LatLngBounds();

    // Add markers to the map.
    for (let i = 0; i < data.length; i++) {
      const location = data[i];

      // Create marker.
      const marker = GoogleMap.createMarker(location, Portfolios.map);

      // fit markers
      bounds.extend(location);

      // Create infobubble
      let content = $(
        "<div>" +
          '<div class="map-item">' +
          '<div class="map-item__image">' +
          '<div class="map-item__image__inner"><img src="' +
          data[i].image +
          '" alt=""></div>' +
          "</div>" +
          '<div class="map-item__text">' +
          '<h2 class="map-item__title">' +
          data[i].title +
          "</h2>" +
          "</div>" +
          "</div></div>"
      );
      $(".map-item__image__inner img, .offer__title", content).wrap(
        '<a href="' + data[i].permalink + '"></a>'
      );
      $(".map-item__text", content).append(
        '<a href="' +
          data[i].permalink +
          '" class="map-item__more btn btn-solid">' +
          Portfolios.element.data("view") +
          "</a>"
      );
      const infowindow = new google.maps.InfoWindow({
        content: content.html(),
      });

      // Add event to marker
      marker.addListener("click", function () {
        infowindow.open({
          anchor: marker,
          map: Portfolios.map,
        });
      });

      markers.push(marker);
    }

    // Fit markers
    Portfolios.map.fitBounds(bounds);

    // Add a marker clusterer to manage the markers.
    new MarkerClusterer({
      renderer: GoogleMap.renderer,
      map: Portfolios.map,
      markers,
    });
  },
};

export default Portfolios;
